<template>
  <tr>
    <td v-text="botNameById[bot_id]" />
    <select-project
      :value="entity_id"
      readonly
    />
    <td v-text="type" />
    <td v-text="chat_id" />
    <td class="actions">
      <v-btn
        color="primary"
        icon
        @click="$emit('edit')"
      >
        <v-icon>
          edit
        </v-icon>
      </v-btn>
      <v-btn
        icon
        color="error"
        @click="$emit('delete')"
      >
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn
        icon
        color="primary"
        @click="$emit('send-test-message')"
      >
        <v-icon>mdi-send-circle</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

export default {
  components: {
    SelectProject,
  },
  props: {
    bot_id: {
      type: Number,
      required: true,
    },
    entity_id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    chat_id: {
      type: String,
      required: true,
    },

    botNameById: {
      type: Object,
      required: true,
    }
  },
  emits: ['edit', 'send-test-message'],
}
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  gap: 0.5rem;
}
</style>
